import { BqResponse, EmptyObj } from '~/api/def/endpoints/types';
import { defaultServer } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '../../../service/getExecEndpoint';
import { DocumentFieldAPIModel } from './documentFieldEndpoint';

export const documentCapTableEndpoint = {
  server: defaultServer,
  path: 'document',
  description: 'Document cap table endpoints',
};

export interface DocumentCapTableEndpointDef {
  endpoint: typeof documentCapTableEndpoint;
  methods: {
    GET: {
      response: DocumentCapTableResponseGET;
    };
    PATCH: {
      response: DocumentCapTableResponsePATCH;
      payload: DocumentCapTablePatchPayload;
    };
    DELETE: {
      response: DocumentCapTableResponsePATCH;
    };
  };
}

export const AT_TIME = ['pre-completion', 'investment-round'] as const;

const endpointDocumentCapTableExec =
  getExecEndpoint<DocumentCapTableEndpointDef>(documentCapTableEndpoint);

export const endpointDocumentCapTableGET = async (
  documentId: string,
  atTime?: (typeof AT_TIME)[number][],
) => {
  const searchParams = new URLSearchParams();

  if (atTime) {
    searchParams.append('atTime', JSON.stringify(atTime));
  }

  const queryString = searchParams.toString();

  return endpointDocumentCapTableExec<'GET'>({
    method: 'GET',
    urlExtra: `/${documentId}/cap-table${queryString ? `?${queryString}` : ''}`,
  });
};

export type DocumentCapTableResponseGET = BqResponse<{
  data: {
    entries: DocumentCapTableResponse[];
    aggregates: {
      totalSharesCount: string;
    };
    fields: DocumentFieldAPIModel[];
  };
}>;

export type DocumentCapTableResponse = {
  capTableRowId: string;
  shareholder: string;
  shareholderId: string;
  shareClass: string;
  shareClassId: string;
  shareClassIsNormalized: boolean;
  shareCount: string;
  shareCountId: string;
  investmentCurrency: string;
  investmentCurrencyId: string;
  investmentAmount: string;
  investmentAmountId: string;
  pricePerShare: string | number;
  pricePerShareId: string;
  investmentDate: string;
  investmentDateId: string;
  approvedBy: string | null;
};

export const endpointDocumentCapTablePATCH = async (
  documentId: string,
  rowId: string,
  payload: DocumentCapTablePatchPayload,
) =>
  endpointDocumentCapTableExec<'PATCH'>({
    method: 'PATCH',
    urlExtra: `/${documentId}/cap-table/${rowId}`,
    payload: payload,
  });

type DocumentCapTablePatchPayload = {
  updatedFields: Array<{
    id: string;
    value: string;
  }>;
};

type DocumentCapTableResponsePATCH = BqResponse<{ data: EmptyObj }>;

export const endpointDocumentCapTableDelete = async (
  documentId: string,
  rowId: string,
) =>
  endpointDocumentCapTableExec<'DELETE'>({
    method: 'DELETE',
    urlExtra: `/${documentId}/cap-table/${rowId}`,
  });
